import { render, staticRenderFns } from "./BenefitTypes.vue?vue&type=template&id=52e2db5c&"
import script from "./BenefitTypes.vue?vue&type=script&lang=js&"
export * from "./BenefitTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports